
import { defineComponent, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import OrderHistTbl from '@/components/OrderHistTbl.vue'
import { app } from '../main'
import { User } from '@/types/clsUser'

export default defineComponent({
  components: { OrderHistTbl },
  props: ['user'],
  setup (props, context) {
    const router = useRouter()
    if (!props.user.login) {
      console.log('Can\'t access Hist for not login.')
      router.back()
    }
    const loading = ref(false)
    const message = reactive({
      msg: '',
      err: false,
      clear () {
        this.msg = ''
        this.err = false
      }
    })
    const orderList: JSON[] = reactive([])
    const getHist = () => {
      loading.value = true
      const apiPath = app.config.globalProperties.api_path
      fetch(apiPath + 'ajax/orderhist.php', {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      }).then(response => response.json())
        .then(json => {
          // console.log(json)
          if (json.result === 'failure') {
            if (json.err_code === 9) {
              context.emit('login', new User())
            }
            throw new Error(json.error)
          }
          message.clear()
          Object.assign(orderList, json)
        })
        .catch(error => {
          console.error(error)
          message.msg = error.message
          message.err = true
        })
        .finally(() => {
          loading.value = false
        })
    }
    getHist()

    return {
      message,
      orderList,
      loading
    }
  }
})
